export default __webpack_public_path__ + "static/media/gallery_08.0436a6b7.jpg";